export default __webpack_public_path__ + "resources/icons/d332-98b0.webp";